module.exports = __webpack_public_path__ + "img/ic_plant_name.0bca7f1e.png";